// frontend/src/pages/DocsViewer.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github.css';

const DocsViewer = () => {
  const [markdown, setMarkdown] = useState('Loading...');
  const [rawContent, setRawContent] = useState('');

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/docs/scan`);
        setMarkdown(res.data);
        setRawContent(res.data);
      } catch (err) {
        console.error('❌ Failed to fetch docs:', err);
        setMarkdown('# Error\nCould not load documentation.');
      }
    };

    fetchDocs();
  }, []);

  const handleDownload = () => {
    const blob = new Blob([rawContent], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'code_blueprint.md';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold">📄 Project Code Blueprint</h1>
        <button
          onClick={handleDownload}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          ⬇️ Download .md
        </button>
      </div>

      <div className="prose prose-sm sm:prose lg:prose-lg xl:prose-xl">
        <ReactMarkdown rehypePlugins={[rehypeHighlight]}>
          {markdown}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default DocsViewer;
